export const currencyList = [
   {
      code: 'AED',
      name: 'UAE',
      flag: '🇦🇪',
      symbol: '',
   },
   {
      code: 'USD',
      name: 'International',
      flag: '🇺🇸',
      symbol: '$',
   },
   {
      code: 'SAR',
      name: 'KSA',
      flag: '🇸🇦',
   },
   {
      code: 'KWD',
      name: 'Kuwait',
      flag: '🇰🇼',
   },
   {
      code: 'JOD',
      name: 'Jordan',
      flag: '🇯🇴',
   },
   {
      code: 'QAR',
      name: 'Qatar',
      flag: '🇶🇦',
   },
   {
      code: 'EUR',
      name: 'EU',
      symbol: '€',
      flag: '🇪🇺',
   },
   {
      code: 'GBP',
      name: 'UK',
      symbol: '£',
      flag: '🇬🇧',
   },
   {
      code: 'BHD',
      name: 'BH',
      flag: '🇧🇭',
   },
];
